(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  (() => {
  const root = document.querySelector('[data-cart-root]');
  const dialog = root?.querySelector('[data-cart-dialog]');

  if (root && dialog) {
    const error = root.querySelector('[data-cart-error]');
    const sectionId = root.dataset.sectionId;

    const setCount = (count) => {
      document.querySelectorAll('[data-cart-count]').forEach((node) => {
        node.textContent = count;
        node.hidden = count === '0';
      });
    };

    const showError = (message) => {
      if (!error) return;
      error.textContent = message;
      error.hidden = false;
    };

    const clearError = () => {
      if (!error) return;
      error.textContent = '';
      error.hidden = true;
    };

    const applySection = (html) => {
      if (!html) return;
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const freshStyles = parsed.querySelector('style[data-section-stylesheet]');
      if (freshStyles) {
        const marker = `style[data-cart-styles="${sectionId}"]`;
        document.head.querySelector(marker)?.remove();
        const style = freshStyles.cloneNode(true);
        style.setAttribute('data-cart-styles', sectionId);
        document.head.append(style);
      }
      const nextBody = parsed.querySelector('[data-cart-body]');
      const body = root.querySelector('[data-cart-body]');
      if (nextBody && body) body.replaceWith(nextBody);
      const nextFooter = parsed.querySelector('[data-cart-footer]');
      const footer = root.querySelector('[data-cart-footer]');
      if (nextFooter && footer) footer.replaceWith(nextFooter);
      const count = parsed.querySelector('[data-cart-count-source]')?.textContent?.trim() || '0';
      setCount(count);
    };

    const postCart = async (url, body) => {
      dialog.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, {
          method: 'POST',
          body,
          headers: { Accept: 'application/json' },
        });
        const payload = await response.json();
        if (!response.ok) {
          showError(payload.description || payload.message || root.dataset.error);
          openCart();
          return null;
        }
        clearError();
        let html = payload.sections?.[sectionId];
        if (!html) {
          const rootUrl = window.Shopify?.routes?.root || '/';
          const extra = await fetch(`${rootUrl}?sections=${sectionId}`, { headers: { Accept: 'application/json' } });
          const sections = await extra.json();
          html = sections[sectionId];
        }
        applySection(html);
        return payload;
      } catch {
        showError(root.dataset.error);
        return null;
      } finally {
        dialog.removeAttribute('aria-busy');
      }
    };

    let closeTimer = 0;
    let onCloseEnd = null;

    const finishClose = () => {
      window.clearTimeout(closeTimer);
      if (onCloseEnd) dialog.removeEventListener('transitionend', onCloseEnd);
      onCloseEnd = null;
      dialog.classList.remove('is-closing');
      if (dialog.open) dialog.close();
      document.querySelector('[data-cart-open]')?.setAttribute('aria-expanded', 'false');
    };

    const openCart = () => {
      window.clearTimeout(closeTimer);
      if (onCloseEnd) dialog.removeEventListener('transitionend', onCloseEnd);
      onCloseEnd = null;
      dialog.classList.remove('is-closing');
      if (!dialog.open) dialog.showModal();
      document.querySelector('[data-cart-open]')?.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-cart-close]')?.focus();
    };

    const closeCart = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finishClose();
        return;
      }
      dialog.classList.add('is-closing');
      onCloseEnd = (event) => {
        if (event.propertyName !== 'transform') return;
        finishClose();
      };
      dialog.addEventListener('transitionend', onCloseEnd);
      closeTimer = window.setTimeout(finishClose, 400);
    };

    document.querySelector('[data-cart-open]')?.addEventListener('click', (event) => {
      event.preventDefault();
      openCart();
    });

    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeCart();
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-cart-close]')) closeCart();
    });

    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-cart-qty]');
      if (!button) return;
      const body = new FormData();
      body.append('id', button.dataset.line);
      body.append('quantity', button.dataset.qty);
      body.append('sections', sectionId);
      postCart(`${root.dataset.cartChange}.js`, body);
    });

    root.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-cart-discount')) return;
      event.preventDefault();
      const body = new FormData(form);
      body.append('sections', sectionId);
      postCart(`${root.dataset.cartUpdate}.js`, body).then((payload) => {
        const rejected = payload?.discount_codes?.find((code) => code.applicable === false);
        if (rejected) showError(root.dataset.discountError);
      });
    });

    document.addEventListener('click', (event) => {
      const button = event.target.closest('[data-quick-add]');
      if (!button || button.disabled) return;
      const picker = button.closest('.product-card__quick')?.querySelector('[data-quick-variant]');
      const id = picker?.value || button.dataset.variant;
      if (!id) return;
      const body = new FormData();
      body.append('id', id);
      body.append('quantity', '1');
      body.append('sections', sectionId);
      button.setAttribute('aria-busy', 'true');
      postCart(`${root.dataset.cartAdd}.js`, body).then((payload) => {
        button.removeAttribute('aria-busy');
        if (payload) openCart();
      });
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement) || form.dataset.cartAdd !== 'product') return;
      if (event.submitter?.name) return;
      event.preventDefault();
      const button = event.submitter;
      button?.setAttribute('aria-busy', 'true');
      const body = new FormData(form);
      if (!body.get('selling_plan')) body.delete('selling_plan');
      body.delete('box_size');
      body.delete('delivery_frequency');
      const giftMessage = body.get('properties[Gift Message]');
      if (typeof giftMessage !== 'string' || !giftMessage.trim()) body.delete('properties[Gift Message]');
      else body.set('properties[Gift Message]', giftMessage.trim());
      body.append('sections', sectionId);
      postCart(`${root.dataset.cartAdd}.js`, body).then((payload) => {
        button?.removeAttribute('aria-busy');
        if (payload) openCart();
      });
    });
  }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    if (window.__chilliCollectionFilters) return;
    window.__chilliCollectionFilters = true;

    let requestId = 0;

    const buildFormUrl = (form) => {
      const next = new URL(form.getAttribute('action'), window.location.origin);
      next.search = new URLSearchParams(new FormData(form)).toString();
      return next;
    };

    const loadCollection = async (url, push) => {
      const current = document.querySelector('[data-collection]');
      const sectionId = current?.dataset.sectionId;
      if (!current || !sectionId) {
        window.location.assign(url);
        return;
      }

      const id = ++requestId;
      const next = new URL(url, window.location.origin);
      const openGroups = [...current.querySelectorAll('.collection-main__group[open] summary span')].map(
        (node) => node.textContent
      );
      next.searchParams.set('section_id', sectionId);
      current.classList.add('is-loading');

      try {
        const response = await fetch(next);
        if (!response.ok) throw new Error('filter request failed');
        const html = await response.text();
        if (id !== requestId) return;
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const fresh = parsed.querySelector(`#shopify-section-${sectionId}`);
        const host = document.getElementById(`shopify-section-${sectionId}`);
        if (!fresh || !host) throw new Error('filter section missing');
        host.innerHTML = fresh.innerHTML;
        host.querySelectorAll('.collection-main__group').forEach((group) => {
          const title = group.querySelector('summary span')?.textContent;
          if (openGroups.includes(title)) group.open = true;
        });
        next.searchParams.delete('section_id');
        if (push) history.pushState({}, '', `${next.pathname}${next.search}`);
      } catch {
        if (id === requestId) window.location.assign(url);
      }
    };

    document.addEventListener('change', (event) => {
      const field = event.target;
      if (!(field instanceof HTMLElement)) return;
      const form = field.closest('[data-filter-form], [data-filter-sort]');
      if (!form) return;
      if (field instanceof HTMLInputElement && field.type !== 'checkbox') return;
      if (!(field instanceof HTMLInputElement) && !(field instanceof HTMLSelectElement)) return;
      loadCollection(buildFormUrl(form), true);
    });

    document.addEventListener('click', (event) => {
      const link = event.target.closest('[data-filter-link]');
      if (!link) return;
      event.preventDefault();
      loadCollection(link.href, true);
    });

    document.addEventListener('submit', (event) => {
      const form = event.target;
      if (!(form instanceof HTMLFormElement)) return;
      if (!form.hasAttribute('data-filter-form') && !form.hasAttribute('data-filter-sort')) return;
      event.preventDefault();
      loadCollection(buildFormUrl(form), true);
    });

    window.addEventListener('popstate', () => {
      loadCollection(window.location.href, false);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    const dialog = document.getElementById('SiteMenu');
    const opener = document.querySelector('[data-menu-open]');
    if (!dialog || !opener) return;

    let closeTimer = 0;
    let onCloseEnd = null;

    const finishClose = () => {
      window.clearTimeout(closeTimer);
      if (onCloseEnd) dialog.removeEventListener('transitionend', onCloseEnd);
      onCloseEnd = null;
      dialog.classList.remove('is-closing');
      if (dialog.open) dialog.close();
      opener.setAttribute('aria-expanded', 'false');
    };

    const openMenu = () => {
      window.clearTimeout(closeTimer);
      if (onCloseEnd) dialog.removeEventListener('transitionend', onCloseEnd);
      onCloseEnd = null;
      dialog.classList.remove('is-closing');
      if (!dialog.open) dialog.showModal();
      opener.setAttribute('aria-expanded', 'true');
      dialog.querySelector('[data-menu-close]')?.focus();
    };

    const closeMenu = () => {
      if (!dialog.open || dialog.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        finishClose();
        return;
      }
      dialog.classList.add('is-closing');
      onCloseEnd = (event) => {
        if (event.propertyName !== 'transform') return;
        finishClose();
      };
      dialog.addEventListener('transitionend', onCloseEnd);
      closeTimer = window.setTimeout(finishClose, 400);
    };

    opener.addEventListener('click', openMenu);
    dialog.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeMenu();
    });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('[data-menu-close], .site-menu__nav a')) closeMenu();
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-cart-open]')) closeMenu();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-gift-save]');
    if (!button) return;
    const wrap = button.closest('[data-gift-message]');
    const field = wrap?.querySelector('[data-gift-input]');
    const status = wrap?.querySelector('[data-gift-status]');
    if (!(field instanceof HTMLTextAreaElement) || !status) return;
    field.value = field.value.trim();
    status.textContent = field.value ? status.dataset.saved : status.dataset.cleared;
    status.hidden = false;
  });

  document.addEventListener('input', (event) => {
    if (!(event.target instanceof HTMLTextAreaElement) || !event.target.matches('[data-gift-input]')) return;
    const status = event.target.closest('[data-gift-message]')?.querySelector('[data-gift-status]');
    if (status) status.hidden = true;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
  const related = document.querySelector('[data-related]');
  if (related && !related.dataset.loaded) {
    related.dataset.loaded = 'true';
    fetch(related.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const next = parsed.querySelector('[data-related]');
        const freshStyles = parsed.querySelector('style[data-section-stylesheet]');
        const host = related.closest('.shopify-section');
        if (freshStyles && host) {
          host.querySelector('style[data-section-stylesheet]')?.remove();
          host.prepend(freshStyles);
        }
        if (next) related.innerHTML = next.innerHTML;
      });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["signup-popup"]) return;
  try {
    
  const popup = document.querySelector('[data-signup-popup]');
  if (popup && popup.dataset.bound !== 'true') {
    popup.dataset.bound = 'true';
    const designMode = window.Shopify && Shopify.designMode;
    const cookieName = 'ci_signup';
    const remembered = () => document.cookie.split('; ').some((row) => row.startsWith(`${cookieName}=`));
    const remember = () => {
      if (designMode) return;
      document.cookie = `${cookieName}=1; Max-Age=15552000; Path=/; SameSite=Lax; Secure`;
    };

    popup.addEventListener('close', remember);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) popup.close();
    });
    popup.querySelector('[data-signup-close]')?.addEventListener('click', () => popup.close());

    const openPopup = () => {
      if (popup.open || document.querySelector('dialog[open]')) return;
      popup.showModal();
    };

    const showThanks = () => {
      popup.querySelector('[data-signup-offer]')?.setAttribute('hidden', '');
      const thanks = popup.querySelector('[data-signup-success]');
      if (thanks) thanks.hidden = false;
      popup.setAttribute('aria-labelledby', 'SignupPopupThanks');
      openPopup();
      remember();
    };

    const welcome = new URLSearchParams(window.location.search).get('welcome') === '1';
    if (welcome || popup.hasAttribute('data-signup-thanks')) {
      showThanks();
    } else if (popup.hasAttribute('data-signup-open')) {
      openPopup();
    } else if (designMode || !remembered()) {
      window.setTimeout(openPopup, Number(popup.dataset.delay) || 4000);
    }
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["subscribe-plans"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const parseAllocations = (input) => {
      try {
        return JSON.parse(input?.dataset.allocations || '[]');
      } catch {
        return [];
      }
    };

    const syncSubscribe = (form) => {
      const plan = form.querySelector('[data-plan]:checked');
      const heat = form.querySelector('[data-heat]:checked');
      let frequency = form.querySelector('[data-frequency]:checked');
      const variant = form.querySelector('[data-variant-id]');
      const selling = form.querySelector('[data-selling-plan]');
      const summary = form.querySelector('[data-subscribe-summary]');
      const button = form.querySelector('[data-subscribe-submit]');
      const allocations = parseAllocations(plan);

      form.querySelectorAll('[data-frequency]').forEach((input) => {
        const found = allocations.find((item) => item.name === input.value);
        const choice = input.closest('.plans__choice');
        input.disabled = allocations.length > 0 && !found;
        choice?.classList.toggle('is-unavailable', input.disabled);
      });

      if (frequency?.disabled) {
        frequency.checked = false;
        const next = form.querySelector('[data-frequency]:not(:disabled)');
        if (next) next.checked = true;
        frequency = form.querySelector('[data-frequency]:checked');
      }

      const match = allocations.find((item) => item.name === frequency?.value) || allocations[0];
      if (variant) variant.value = plan?.dataset.variant || '';
      if (selling) selling.value = match?.id || '';

      form.querySelectorAll('[data-plan]').forEach((input) => {
        const items = parseAllocations(input);
        const found = items.find((item) => item.name === (frequency?.value || match?.name)) || items[0];
        const price = input.closest('.plans__choice')?.querySelector('[data-plan-price]');
        if (price && found?.price) price.textContent = found.price;
      });

      if (summary) {
        const parts = [plan?.dataset.label, heat?.value, frequency?.value || match?.name, match?.price].filter(Boolean);
        summary.hidden = parts.length === 0;
        summary.textContent = parts.join(' · ');
      }
      const needsFrequency = Boolean(form.querySelector('[data-frequency]'));
      if (button) button.disabled = !plan || !heat || (needsFrequency && !frequency);
    };

    const start = () => {
      document.querySelectorAll('[data-subscribe-form]').forEach(syncSubscribe);
    };

    document.addEventListener('change', (event) => {
      const form = event.target.closest?.('[data-subscribe-form]');
      if (form) syncSubscribe(form);
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start);
    } else {
      start();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-divider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.__chilliWaves) return;
    window.__chilliWaves = true;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    if (reduce.matches) return;

    let frame = 0;

    const update = () => {
      frame = 0;
      const height = window.innerHeight || 1;
      const travel = Math.min(height * 0.22, 200);
      document.querySelectorAll('[data-wave]').forEach((wave) => {
        const rect = wave.getBoundingClientRect();
        const center = rect.top + rect.height * 0.5;
        const progress = (height * 0.5 - center) / height;
        const limited = Math.max(-1, Math.min(1, progress));
        wave.style.setProperty('--wave-shift', `${(limited * travel).toFixed(1)}px`);
      });
    };

    const request = () => {
      if (frame) return;
      frame = requestAnimationFrame(update);
    };

    update();
    window.addEventListener('scroll', request, { passive: true });
    window.addEventListener('resize', request);
    window.visualViewport?.addEventListener('scroll', request, { passive: true });
    window.visualViewport?.addEventListener('resize', request);
  })();

  } catch(e) { console.error(e); }
})();
})();
